export const AUTH_KEYS = {
  LOGIN: 'AUTH_LOGIN',
  LOGOUT: 'AUTH_LOGOUT',
  HEALTH_CHECK: 'HEALTH_CHECK',
  SESSION: 'AUTH_SESSION',
};

export const AUTH_TOAST_MESSAGES = {
  LOGIN_SUCCESS: '로그인에 성공했습니다.',
  LOGIN_FAILED: '로그인에 실패하였습니다.',
  LOGOUT_SUCCESS: '로그아웃 되었습니다.',
  LOGIN_EXPIRED: '로그인 시간이 만료되었습니다. 다시 로그인해주세요.',
  HEALTH_CHECK_FAILED: '서버 상태가 정상이 아닙니다. 잠시 후 다시 시도해주세요.',
  HEALTH_CHECK_SUCCESS: '서버 상태가 정상입니다.',
  HEALTH_CHECK_SUCCESS_2: '아 그만하라고 된다니까 ㅋㅋ',
  HEALTH_CHECK_SUCCESS_3: '사이트 터진다 ㅅㄱ',
};
